<template>
  <v-dialog
    v-model="dialog"
    scrollable
    overlay-opacity="0.6"
    persistent
    width="1200"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        rounded
        color="warning"
        class="ms-2 text-capitalize"
        depressed
      >
        Yeni Ekle
      </v-btn>
    </template>

    <v-card
      :loading="dialogLoading"
      :disabled="dialogLoading"
      :class="{
        'scrollable-card': !isScroll,
        'scrollable-text-card': !isScroll && $vuetify.breakpoint.mdAndDown,
        'scrollable-not-card': !isScroll && arrivedState.bottom,
      }"
    >
      <v-card-title class="grey">
        <div
          class="d-flex align-center justify-space-between"
          style="width: 100%"
        >
          <div class="d-flex align-center">
            <v-icon color="white" size="48">
              {{ icons.mdiCashRegister }}
            </v-icon>

            <div class="text-h5 font-weight-bold ms-3 white--text">
              Günlük Kasa Raporu
            </div>
          </div>
          <v-btn color="grey" depressed fab @click="closeForm()">
            <v-icon large>
              {{ icons.mdiCloseCircleOutline }}
            </v-icon>
          </v-btn>
        </div>
      </v-card-title>
      <v-divider />

      <v-card-text class="py-5" ref="scrollableEl" style="height: 100dvh">
        <validation-observer ref="form" tag="div">
          <v-row>
            <v-col cols="8">
              <v-card style="border-radius: 12px" class="overflow-hidden">
                <v-row no-gutters>
                  <v-col cols="7">
                    <v-text-field
                      v-model="formData['field[banka_yatan_tutar]']"
                      label="Bankaya Yatan Tutar"
                      suffix="TL"
                      type="number"
                      min="0"
                      filled
                      hide-details
                    />
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      v-model="formData['field[banka_yatan_tutar_aciklama]']"
                      placeholder="Açıklama"
                      tabindex="-1"
                      persistent-placeholder
                      filled
                      hide-details
                    />
                  </v-col>
                </v-row>
                <v-divider />
                <v-row no-gutters>
                  <v-col cols="7">
                    <v-text-field
                      v-model="formData['field[nakit_iade_tutar]']"
                      label="Nakit İade Tutar"
                      suffix="TL"
                      type="number"
                      min="0"
                      filled
                      hide-details
                    />
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      v-model="formData['field[nakit_iade_tutar_aciklama]']"
                      placeholder="Açıklama"
                      tabindex="-1"
                      persistent-placeholder
                      filled
                      hide-details
                    />
                  </v-col>
                </v-row>
                <v-divider />
                <v-row no-gutters>
                  <v-col cols="7">
                    <validation-provider
                      v-slot="{ errors }"
                      tag="div"
                      mode="eager"
                      rules="required"
                    >
                      <v-text-field
                        v-model="formData['field[kapanis_nakit_tutar]']"
                        label="Kapanıştakı Sayılan Nakit Tutar"
                        suffix="TL"
                        type="number"
                        min="0"
                        filled
                        hide-details
                        :error-messages="errors"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      v-model="formData['field[kapanis_nakit_tutar_aciklama]']"
                      placeholder="Açıklama"
                      tabindex="-1"
                      persistent-placeholder
                      filled
                      hide-details
                    />
                  </v-col>
                </v-row>
                <v-divider />
                <v-row no-gutters>
                  <v-col cols="7">
                    <validation-provider
                      v-slot="{ errors }"
                      tag="div"
                      mode="eager"
                      rules="required"
                    >
                      <v-text-field
                        v-model="formData['field[gelir_nakit]']"
                        label="Nakit Gelir"
                        suffix="TL"
                        type="number"
                        min="0"
                        filled
                        hide-details
                        :error-messages="errors"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      v-model="formData['field[gelir_nakit_aciklama]']"
                      placeholder="Açıklama"
                      tabindex="-1"
                      persistent-placeholder
                      filled
                      hide-details
                    />
                  </v-col>
                </v-row>
                <v-divider />
                <v-row no-gutters>
                  <v-col cols="7">
                    <validation-provider
                      v-slot="{ errors }"
                      tag="div"
                      mode="eager"
                      rules="required"
                    >
                      <v-text-field
                        v-model="formData['field[gelir_kredikarti]']"
                        label="Kredi Kartı Gelir"
                        suffix="TL"
                        type="number"
                        min="0"
                        filled
                        hide-details
                        :error-messages="errors"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      v-model="formData['field[gelir_kredikarti_aciklama]']"
                      placeholder="Açıklama"
                      tabindex="-1"
                      persistent-placeholder
                      filled
                      hide-details
                    />
                  </v-col>
                </v-row>
                <v-divider />
                <v-row no-gutters>
                  <v-col cols="7">
                    <v-text-field
                      v-model="formData['field[toplam_cari]']"
                      label="Toplam Cari"
                      suffix="TL"
                      type="number"
                      min="0"
                      filled
                      hide-details
                    />
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      v-model="formData['field[toplam_cari_aciklama]']"
                      placeholder="Açıklama"
                      tabindex="-1"
                      persistent-placeholder
                      filled
                      hide-details
                    />
                  </v-col>
                </v-row>

                <v-divider />
                <v-row no-gutters>
                  <v-col cols="7">
                    <v-text-field
                      v-model="formData['field[gelir_getir]']"
                      label="Getir"
                      suffix="TL"
                      type="number"
                      min="0"
                      filled
                      hide-details
                    />
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      v-model="formData['field[gelir_getir_aciklama]']"
                      placeholder="Açıklama"
                      tabindex="-1"
                      persistent-placeholder
                      filled
                      hide-details
                    />
                  </v-col>
                </v-row>
                <v-divider />
                <v-row no-gutters>
                  <v-col cols="7">
                    <v-text-field
                      v-model="formData['field[gelir_yemeksepeti]']"
                      label="Yemek Sepeti"
                      suffix="TL"
                      type="number"
                      min="0"
                      filled
                      hide-details
                    />
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      v-model="formData['field[gelir_yemeksepeti_aciklama]']"
                      placeholder="Açıklama"
                      tabindex="-1"
                      persistent-placeholder
                      filled
                      hide-details
                    />
                  </v-col>
                </v-row>
                <v-divider />
                <v-row no-gutters>
                  <v-col cols="7">
                    <v-text-field
                      v-model="formData['field[gelir_trendyol]']"
                      label="Trendyol"
                      suffix="TL"
                      type="number"
                      min="0"
                      filled
                      hide-details
                    />
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      v-model="formData['field[gelir_trendyol_aciklama]']"
                      placeholder="Açıklama"
                      tabindex="-1"
                      persistent-placeholder
                      filled
                      hide-details
                    />
                  </v-col>
                </v-row>
                <v-divider />
                <v-row no-gutters>
                  <v-col cols="7">
                    <v-text-field
                      v-model="formData['field[gelir_digeronline]']"
                      label="Diğer Online Ödemeler"
                      placeholder="Ticket Online, Migros Online, Call Center"
                      suffix="TL"
                      type="number"
                      min="0"
                      filled
                      hide-details
                    />
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      v-model="formData['field[gelir_digeronline_aciklama]']"
                      placeholder="Açıklama"
                      tabindex="-1"
                      persistent-placeholder
                      filled
                      hide-details
                    />
                  </v-col>
                </v-row>
                <v-divider />
                <v-row no-gutters>
                  <v-col cols="7">
                    <v-text-field
                      v-model="formData['field[gelir_metropol]']"
                      label="Metropol"
                      suffix="TL"
                      type="number"
                      min="0"
                      filled
                      hide-details
                    />
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      v-model="formData['field[gelir_metropol_aciklama]']"
                      placeholder="Açıklama"
                      tabindex="-1"
                      persistent-placeholder
                      filled
                      hide-details
                    />
                  </v-col>
                </v-row>
                <v-divider />
                <v-row no-gutters>
                  <v-col cols="7">
                    <v-text-field
                      v-model="formData['field[gelir_multinet]']"
                      label="Multinet"
                      suffix="TL"
                      type="number"
                      min="0"
                      filled
                      hide-details
                    />
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      v-model="formData['field[gelir_multinet_aciklama]']"
                      placeholder="Açıklama"
                      tabindex="-1"
                      persistent-placeholder
                      filled
                      hide-details
                    />
                  </v-col>
                </v-row>
                <v-divider />
                <v-row no-gutters>
                  <v-col cols="7">
                    <v-text-field
                      v-model="formData['field[gelir_setcard]']"
                      label="Setcard"
                      placeholder="Cihazından Gün Sonuna Bakılmalı"
                      suffix="TL"
                      type="number"
                      min="0"
                      filled
                      hide-details
                    />
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      v-model="formData['field[gelir_setcard_aciklama]']"
                      placeholder="Açıklama"
                      tabindex="-1"
                      persistent-placeholder
                      filled
                      hide-details
                    />
                  </v-col>
                </v-row>
                <v-divider />
                <v-row no-gutters>
                  <v-col cols="7">
                    <v-text-field
                      v-model="formData['field[gelir_sodexo]']"
                      label="Sodexo"
                      suffix="TL"
                      type="number"
                      min="0"
                      filled
                      hide-details
                    />
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      v-model="formData['field[gelir_sodexo_aciklama]']"
                      placeholder="Açıklama"
                      tabindex="-1"
                      persistent-placeholder
                      filled
                      hide-details
                    />
                  </v-col>
                </v-row>
                <v-divider />
                <v-row no-gutters>
                  <v-col cols="7">
                    <v-text-field
                      v-model="formData['field[gelir_edenred]']"
                      label="Edenred / Ticket"
                      suffix="TL"
                      type="number"
                      min="0"
                      filled
                      hide-details
                    />
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      v-model="formData['field[gelir_edenred_aciklama]']"
                      placeholder="Açıklama"
                      tabindex="-1"
                      persistent-placeholder
                      filled
                      hide-details
                    />
                  </v-col>
                </v-row>
                <v-divider />
                <v-row no-gutters>
                  <v-col cols="7">
                    <v-text-field
                      v-model="formData['field[gelir_yk_diger]']"
                      label="Diğer Yemek Çekleri"
                      suffix="TL"
                      type="number"
                      min="0"
                      filled
                      hide-details
                    />
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      v-model="formData['field[gelir_yk_diger_aciklama]']"
                      placeholder="Açıklama"
                      tabindex="-1"
                      persistent-placeholder
                      filled
                      hide-details
                    />
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="4">
              <div style="position: sticky; top: 0">
                <v-card
                  :disabled="isDateChange"
                  class="mb-3"
                  color="white"
                  flat
                  width="100%"
                >
                  <div
                    class="chip--text font-weight-bold text-caption"
                    style="padding: 8px 0px 0px 14px"
                  >
                    Rapor Tarihi
                  </div>
                  <div class="mt-n3">
                    <v-menu
                      v-model="menu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="formData['field[form_date]']"
                          solo
                          light
                          :append-icon="icons.mdiCalendarRange"
                          background-color="transparent"
                          hide-details
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="formData['field[form_date]']"
                        @input="menu = false"
                        @change="test"
                        :max="new Date().toISOString().split('T')[0]"
                        no-title
                      >
                      </v-date-picker>
                    </v-menu>
                  </div>
                </v-card>
                <v-card
                  v-if="!isClosed"
                  color="counter"
                  class="overflow-hidden"
                >
                  <v-simple-table
                    style="background-color: transparent !important"
                    light
                    dense
                  >
                    <template v-slot:default>
                      <tbody>
                        <tr>
                          <td
                            class="px-3 text-caption"
                            style="color: #28243d !important"
                          >
                            Başlangıç Nakit Tutar
                          </td>
                          <td class="text-caption text-end">
                            {{ kapanisNakitTutar | currency }}
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 text-caption"
                            style="color: #28243d !important"
                          >
                            Nakit Satışlar
                          </td>
                          <td class="text-caption text-end">
                            {{ formData["field[gelir_nakit]"] | currency }}
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 text-caption"
                            style="color: #28243d !important"
                          >
                            Online Ödeme Toplam
                          </td>
                          <td class="text-caption text-end">
                            {{ onlinePaymentSub | currency }}
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 text-caption"
                            style="color: #28243d !important"
                          >
                            Yemek Çekleri Toplam
                          </td>
                          <td class="text-caption text-end">
                            {{ foodStampsSub | currency }}
                          </td>
                        </tr>

                        <tr>
                          <td colspan="2" class="px-0">
                            <validation-provider
                              v-slot="{ errors }"
                              tag="div"
                              mode="eager"
                              rules="required"
                            >
                              <v-text-field
                                v-model="formData['field[hazirlayan_adsoyad]']"
                                background-color="white"
                                light
                                filled
                                label="Hazırlayan Ad soyad"
                                hide-details
                                :error-messages="errors"
                              />
                            </validation-provider>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="2" class="px-0">
                            <validation-provider
                              v-slot="{ errors }"
                              tag="div"
                              mode="eager"
                              rules="required"
                            >
                              <v-text-field
                                v-model="formData['field[hazirlayan_sicilno]']"
                                background-color="white"
                                light
                                filled
                                label="Hazırlayan Sicil Numarası"
                                hide-details
                                :error-messages="errors"
                              />
                            </validation-provider>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
                <v-alert v-else type="warning" prominent text>
                  <div>
                    Bu tarihe önceden kayıt girilmiş. Lütfen yukarıdan rapor
                    tarihini değiştirin
                  </div>
                </v-alert>

                <v-btn
                  block
                  v-if="!isClosed"
                  color="secondary"
                  @click="addData()"
                  x-large
                  class="mt-3 rounded-lg"
                >
                  Kaydet
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </validation-observer>
      </v-card-text>

      <v-card-actions> </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { computed, nextTick, ref, watch } from "vue-demi";

// Utils
import { postData } from "@utils";
import { useScroll, useResizeObserver } from "@vueuse/core";
import { useToast } from "vue-toastification/composition";

// Icons
import {
  mdiCashRegister,
  mdiCloseCircleOutline,
  mdiCalendarRange,
} from "@mdi/js";

export default {
  emits: ["saveData"],
  setup(props, { emit }) {
    const toast = useToast();

    const dialog = ref(false);
    const dialogLoading = ref(false);
    const isSuccess = ref(false);

    // Kaydırma çubuğu
    const scrollableEl = ref(null);
    const { arrivedState } = useScroll(scrollableEl);
    const isScroll = ref(false);

    // Ekran boyutu algılama
    useResizeObserver(scrollableEl, (entries) => {
      isScroll.value =
        scrollableEl.value?.scrollHeight === scrollableEl?.value.offsetHeight;
    });

    const form = ref(null);
    const menu = ref(null);
    const formData = ref({
      method: "saveCashForm",
      "field[form_date]": new Date().toISOString().split("T")[0],
      "field[hazirlayan_sicilno]": null,
      "field[hazirlayan_adsoyad]": null,

      "field[banka_yatan_tutar]": null,
      "field[banka_yatan_tutar_aciklama]": null,
      "field[nakit_iade_tutar]": null,
      "field[nakit_iade_tutar_aciklama]": null,
      "field[kapanis_nakit_tutar]": null,
      "field[kapanis_nakit_tutar_aciklama]": null,
      "field[gelir_nakit]": null,
      "field[gelir_nakit_aciklama]": null,
      "field[gelir_kredikarti]": null,
      "field[gelir_kredikarti_aciklama]": null,
      "field[toplam_cari]": null,
      "field[toplam_cari_aciklama]": null,

      "field[gelir_getir]": null,
      "field[gelir_getir_aciklama]": null,
      "field[gelir_trendyol]": null,
      "field[gelir_trendyol_aciklama]": null,
      "field[gelir_yemeksepeti]": null,
      "field[gelir_yemeksepeti_aciklama]": null,
      "field[gelir_digeronline]": null,
      "field[gelir_digeronline_aciklama]": null,

      "field[gelir_metropol]": null,
      "field[gelir_metropol_aciklama]": null,
      "field[gelir_multinet]": null,
      "field[gelir_multinet_aciklama]": null,
      "field[gelir_setcard]": null,
      "field[gelir_setcard_aciklama]": null,
      "field[gelir_sodexo]": null,
      "field[gelir_sodexo_aciklama]": null,
      "field[gelir_edenred]": null,
      "field[gelir_edenred_aciklama]": null,
      "field[gelir_yk_diger]": null,
      "field[gelir_yk_diger_aciklama]": null,
    });
    const defaultFormData = JSON.parse(JSON.stringify(formData.value));
    const isClosed = ref(true);

    const isDateChange = ref(false);
    const kapanisNakitTutar = ref(null);
    const checkCashForm = async () => {
      isDateChange.value = true;
      const request = {
        method: "checkCashForm",
        form_date: formData.value["field[form_date]"],
      };
      const response = await postData(request);

      if (response.error) {
        toast.error(response.msg);
      }
      kapanisNakitTutar.value =
        response.detail.prev_day_data.kapanis_nakit_tutar;
      isClosed.value = response.detail.is_closed;
      isDateChange.value = false;
    };

    const closeForm = () => {
      dialog.value = false;

      form.value.reset();
      nextTick(() => {
        formData.value = { ...defaultFormData };
      });
    };

    // API İstek
    const addData = async () => {
      const isValid = await form.value.validate();

      if (!isValid) {
        return;
      }

      dialogLoading.value = true;

      postData(...[formData.value])
        .then((response) => {
          // API dönüşündeki hatalara bakıyoruz
          if (response.error) {
            isSuccess.value = false;
            toast.error(response.msg);
            return;
          }
          isSuccess.value = true;
          closeForm();
        })
        .catch((e) => {
          // API hataya girdi

          toast.error(e.message, {
            position: "bottom-center",
          });
        })
        .finally(() => {
          // API işlemi bittikten sonra
          dialogLoading.value = false;
        });
    };

    const onlinePaymentSub = computed(() => {
      return (
        Number(formData.value["field[gelir_getir]"]) +
        Number(formData.value["field[gelir_trendyol]"]) +
        Number(formData.value["field[gelir_yemeksepeti]"]) +
        Number(formData.value["field[gelir_digeronline]"])
      );
    });

    const foodStampsSub = computed(() => {
      return (
        Number(formData.value["field[gelir_metropol]"]) +
        Number(formData.value["field[gelir_multinet]"]) +
        Number(formData.value["field[gelir_setcard]"]) +
        Number(formData.value["field[gelir_edenred]"]) +
        Number(formData.value["field[gelir_yk_diger]"]) +
        Number(formData.value["field[gelir_sodexo]"])
      );
    });
    watch(dialog, (val) => {
      if (val) {
        isScroll.value =
          scrollableEl.value?.scrollHeight === scrollableEl.value?.offsetHeight;
        console.log("Dialog Açıldı");
        checkCashForm();
        isSuccess.value = false;
        dialogLoading.value = false;
      } else {
        console.log("saveData", isSuccess.value);
        emit("saveData", isSuccess.value);
      }
    });

    const test = () => {
      checkCashForm();
    };

    return {
      test,
      menu,

      dialog,
      dialogLoading,

      form,
      formData,
      isClosed,
      isDateChange,
      kapanisNakitTutar,
      onlinePaymentSub,
      foodStampsSub,

      isScroll,
      arrivedState,
      scrollableEl,

      addData,
      closeForm,
      icons: {
        mdiCashRegister,
        mdiCloseCircleOutline,
        mdiCalendarRange,
      },
    };
  },
};
</script>
